// ── SmartTraQ Database Helpers ──
// All Supabase CRUD, mappers, portal helpers, email
// No React, no JSX — only async DB operations
import supabase from './supabase';

// ══════════════════════════════════════════════
// MAPPERS (DB row ↔ app object)
// ══════════════════════════════════════════════
export function dbToOrder(r) { return { id:r.display_id,_uid:r.id,nm:r.name||'',cust:r.customer_name||'',vend:r.vendor_name||'',amt:r.amount||'',frt:r.freight||'',od:r.order_date||'',eta:r.eta||'',pri:r.priority||'Medium',stg:r.stage||'new_inquiry',apr:r.approval||'draft',notes:r.notes||'',tags:r.tags||[],docs:r.docs||{},items:r.items||[],comments:r.comments||[],history:r.history||[],attachments:r.attachments||[],payments:r.payments||[],sid:r.shipment_id||'',cur:r.currency||'USD',incoterm:r.incoterm||'',payTerms:r.pay_terms||'',orderType:r.order_type||'purchase',fulfillment:r.fulfillment||'stock',intermediary:!!r.intermediary,consignee:r.consignee||'',transportMode:r.transport_mode||'',cargoWeight:r.cargo_weight||'',cargoDims:r.cargo_dims||'',cargoPkgs:r.cargo_pkgs||'',revenueCost:r.revenue_cost||{},createdBy:r.created_by_name||'',modifiedBy:'',createdAt:r.created_at,modifiedAt:r.updated_at,archived:!!r.archived_at,archivedAt:r.archived_at||null,archivedBy:r.archived_by||'' } }
export function orderToDb(o,orgId,userId) { return { ...(o._uid?{id:o._uid}:{}),org_id:orgId,display_id:o.id,name:o.nm,customer_name:o.cust,vendor_name:o.vend,amount:o.amt,freight:o.frt,order_date:o.od||null,eta:o.eta||null,priority:o.pri,stage:o.stg,approval:o.apr,notes:o.notes,tags:o.tags||[],docs:o.docs||{},items:o.items||[],comments:o.comments||[],history:o.history||[],attachments:o.attachments||[],payments:o.payments||[],shipment_id:o.sid||null,currency:o.cur||'USD',incoterm:o.incoterm||null,pay_terms:o.payTerms||null,order_type:o.orderType||'purchase',fulfillment:o.fulfillment||'stock',intermediary:!!o.intermediary,consignee:o.consignee||null,transport_mode:o.transportMode||null,cargo_weight:o.cargoWeight||null,cargo_dims:o.cargoDims||null,cargo_pkgs:o.cargoPkgs||null,revenue_cost:o.revenueCost||{},created_by:userId,modified_by:userId,updated_at:new Date().toISOString() } }
export function dbToCust(r) { return { id:r.display_id,_uid:r.id,co:r.company,em:r.email||'',ph:r.phone||'',addr:r.address||'',pipe:r.pipeline||'lead',ct:r.contact||'',val:r.value||'$0',country:r.country||'',website:r.website||'',notes:r.notes||'',archived:!!r.archived_at,archivedAt:r.archived_at||null,archivedBy:r.archived_by||'' } }
export function custToDb(c,orgId,userId) { return { ...(c._uid?{id:c._uid}:{}),org_id:orgId,display_id:c.id,company:c.co,email:c.em,phone:c.ph,address:c.addr,pipeline:c.pipe,contact:c.ct,value:c.val,country:c.country||'',website:c.website||'',notes:c.notes||'',created_by:userId,updated_at:new Date().toISOString() } }
export function dbToVend(r) { return { id:r.display_id,_uid:r.id,co:r.company,em:r.email||'',ph:r.phone||'',addr:r.address||'',rt:r.rating||0,st:r.status||'onboarding',ct:r.contact||'',spec:r.specialties||[],bizType:r.biz_type||'',products:r.products||[],notes:r.notes||'',country:r.country||'',website:r.website||'',archived:!!r.archived_at,archivedAt:r.archived_at||null,archivedBy:r.archived_by||'' } }
export function vendToDb(v,orgId,userId) { return { ...(v._uid?{id:v._uid}:{}),org_id:orgId,display_id:v.id,company:v.co,email:v.em,phone:v.ph,address:v.addr,rating:v.rt||0,status:v.st,contact:v.ct,specialties:v.spec||[],biz_type:v.bizType||'',products:v.products||[],notes:v.notes||'',country:v.country||'',website:v.website||'',created_by:userId,updated_at:new Date().toISOString() } }
export function dbToShip(r) { return { id:r.display_id,_uid:r.id,oid:r.order_id||'',frt:r.freight||'',eta:r.eta||'',car:r.carrier||'',trk:r.tracking_no||'',st:r.status||'processing',orig:r.origin||'',dest:r.destination||'',loc:r.location||'',dprice:r.delivery_price||'',archived:!!r.archived_at,archivedAt:r.archived_at||null,archivedBy:r.archived_by||'' } }
export function shipToDb(s,orgId,userId) { return { ...(s._uid?{id:s._uid}:{}),org_id:orgId,display_id:s.id,order_id:s.oid||null,freight:s.frt,eta:s.eta||null,carrier:s.car,tracking_no:s.trk,status:s.st,origin:s.orig,destination:s.dest,location:s.loc,delivery_price:s.dprice||null,created_by:userId,updated_at:new Date().toISOString() } }
export function dbToTask(r) { return { id:r.id,_uid:r.id,title:r.title,type:r.ref_type||'order',refId:r.ref_id||'',due:r.due_date||'',priority:r.priority||'Medium',assignees:r.assigned_name?[r.assigned_name]:[],createdAt:r.created_at,done:r.status==='done',status:r.status||'todo',note:r.notes||'',subtasks:r.subtasks||[],reminder:r.reminder||'',createdBy:r.created_by_name||'' } }
export function dbToLog(r) { return { id:r.id,at:r.created_at,who:r.actor_name||'System',act:r.action,cat:r.category||'order' } }
export function dbToRfq(r) { return { id:r.display_id,_uid:r.id,oid:r.order_id||'',doc_type:r.doc_type||'rfq',vends:r.vendors||[],cust:r.customer_name||'',items:r.items||[],st:r.status||'sent',sentAt:r.sent_at||r.created_at,incoterm:r.incoterm||'FOB',currency:r.currency||'USD',payTerms:r.pay_terms||'',deliveryLoc:r.delivery_location||'',validityDays:r.validity_days||7,notes:r.notes||'',revenueCost:r.revenue_cost||{},orig:r.origin||'',dest:r.destination||'',total:r.total||0,eta:r.eta||'',nm:r.name||'',awardedVendor:r.awarded_vendor||'' } }
export function rfqToDb(r,orgId,userId) { return { ...(r._uid?{id:r._uid}:{}),org_id:orgId,display_id:r.id,order_id:r.oid||'',doc_type:r.doc_type||'rfq',vendors:r.vends||[],customer_name:r.cust||'',items:r.items||[],status:r.st||'sent',sent_at:r.sentAt||new Date().toISOString(),incoterm:r.incoterm||'FOB',currency:r.currency||'USD',pay_terms:r.payTerms||'',delivery_location:r.deliveryLoc||'',validity_days:r.validityDays||7,notes:r.notes||'',revenue_cost:r.revenueCost||{},origin:r.orig||'',destination:r.dest||'',total:r.total||0,eta:r.eta||'',name:r.nm||'',awarded_vendor:r.awardedVendor||null,created_by:userId,updated_at:new Date().toISOString() } }

// ── Products (with inventory fields) ──
export function dbToProd(r) {
  return {
    id:r.display_id, _uid:r.id,
    nm:r.name||'', sku:r.sku||'', cat:r.category||'general',
    unit:r.unit||'pcs', price:r.price||'', desc:r.description||'',
    moq:r.moq||'', lead:r.lead_time||'', vend:r.vendor||'',
    stock_qty:    r.stock_qty    ?? '',
    reorder_level:r.reorder_level ?? '',
    warehouse:    r.warehouse    || '',
    cost_price:   r.cost_price   || '',
    sell_price:   r.sell_price   || '',
    prod_type:    r.prod_type    || 'stocked',
    hs_code:      r.hs_code      || '',
    hs_regional:  r.hs_regional  || '',
    hs_description:r.hs_description|| '',
    archived:!!r.archived_at, archivedAt:r.archived_at||null, archivedBy:r.archived_by||'',
  };
}
export function prodToDb(p,orgId,userId) {
  return {
    ...(p._uid?{id:p._uid}:{}),
    org_id:orgId, display_id:p.id, name:p.nm,
    sku:p.sku||'', category:p.cat||'general', unit:p.unit||'pcs',
    price:p.price||'', description:p.desc||'',
    moq:p.moq||'', lead_time:p.lead||'', vendor:p.vend||'',
    stock_qty:      p.stock_qty    !=='' ? p.stock_qty    : null,
    reorder_level:  p.reorder_level!=='' ? p.reorder_level : null,
    warehouse:      p.warehouse    || null,
    cost_price:     p.cost_price   || null,
    sell_price:     p.sell_price   || null,
    prod_type:      p.prod_type    || 'stocked',
    hs_code:        p.hs_code      || null,
    hs_regional:    p.hs_regional  || null,
    hs_description: p.hs_description|| null,
    created_by:userId, updated_at:new Date().toISOString(),
  };
}

// ── Stock Movements ──
export function dbToMovement(r) {
  return {
    id:r.id,
    prodId:   r.product_display_id || '',
    prodUid:  r.product_id         || '',
    prodName: r.product_name       || '',
    type:     r.type               || 'adj',
    qty:      r.qty                || 0,
    newQty:   r.new_qty            !== undefined ? r.new_qty : undefined,
    reason:   r.reason             || '',
    orderId:  r.order_id           || null,
    notes:    r.notes              || '',
    status:   r.status             || 'approved',
    createdBy:r.created_by_name    || '',
    approvedBy:r.approved_by_name  || '',
    approvedAt:r.approved_at       || null,
    createdAt:r.created_at,
  };
}

// ══════════════════════════════════════════════
// HELPERS
// ══════════════════════════════════════════════
export const isSupaUser = (s) => !!s;

// ══════════════════════════════════════════════
// PROFILE & ORG DATA
// ══════════════════════════════════════════════
export async function getProfile() {
  if (!supabase) return null;
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data } = await supabase.from('profiles').select('*, organizations(*)').eq('id', user.id).single();
  return data;
}

export async function loadOrgData(orgId) {
  if(!supabase) return {orders:[],custs:[],vends:[],ships:[],tasks:[],rfqs:[],prods:[],logs:[],templates:[],movements:[],invoices:[],tradeDocs:[],notifications:[]};
  const safe=p=>Promise.resolve(p).catch(e=>{console.warn("[SmartTraQ] Query failed:",e);return{data:[],error:e}});
  const timeout=new Promise((_,rej)=>setTimeout(()=>rej(new Error("Load timeout after 15s")),15000));
  const queries=Promise.all([
    safe(supabase.from('orders').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('customers').select('*').eq('org_id',orgId).order('company').limit(500)),
    safe(supabase.from('vendors').select('*').eq('org_id',orgId).order('company').limit(500)),
    safe(supabase.from('shipments').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('tasks').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('rfqs').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(200)),
    safe(supabase.from('products').select('*').eq('org_id',orgId).order('name').limit(500)),
    safe(supabase.from('activity_log').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(100)),
    safe(supabase.from('order_templates').select('*').eq('org_id',orgId)),
    safe(supabase.from('profiles').select('*').eq('org_id',orgId)),
    safe(supabase.from('stock_movements').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('invoices').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('trade_docs').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500)),
    safe(supabase.from('notifications').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(100)),
  ]);
  const [orders,customers,vendors,shipments,tasks,rfqs,products,logs,templates,profiles,movements,invoicesR,tradeDocsR,notifsR] = await Promise.race([queries,timeout]);
  if(orders.error)console.error("[SmartTraQ] orders error:",orders.error);
  if(customers.error)console.error("[SmartTraQ] customers error:",customers.error);
  if(vendors.error)console.error("[SmartTraQ] vendors error:",vendors.error);
  if(shipments.error)console.error("[SmartTraQ] shipments error:",shipments.error);
  if(tasks.error)console.error("[SmartTraQ] tasks error:",tasks.error);
  if(rfqs.error)console.error("[SmartTraQ] rfqs error:",rfqs.error);
  if(products.error)console.error("[SmartTraQ] products error:",products.error);
  if(logs.error)console.error("[SmartTraQ] logs error:",logs.error);
  if(movements.error)console.error("[SmartTraQ] movements error:",movements.error);
  if(invoicesR?.error)console.error("[SmartTraQ] invoices error:",invoicesR.error);
  if(tradeDocsR?.error)console.error("[SmartTraQ] tradeDocs error:",tradeDocsR.error);

  try {
    const teamMembers=(profiles?.data||[]).map(p=>({id:p.id,_uid:p.id,name:p.name,email:p.email,role:p.role||'viewer',av:p.initials||p.name?.charAt(0)||'?',on:p.active!==false,org_id:p.org_id,is_owner:!!p.is_owner}));
    // Map invoices: data stored as jsonb, display_id is the client-side id
    const invoices=(invoicesR?.data||[]).map(r=>({...r.data,_uid:r.id,_dbId:r.display_id}));
    const tradeDocs=(tradeDocsR?.data||[]).map(r=>({...r.data,_uid:r.id,_dbId:r.display_id}));
    return { orders:(orders.data||[]).map(dbToOrder),custs:(customers.data||[]).map(dbToCust),vends:(vendors.data||[]).map(dbToVend),ships:(shipments.data||[]).map(dbToShip),tasks:(tasks.data||[]).map(dbToTask),rfqs:(rfqs.data||[]).map(dbToRfq),prods:(products.data||[]).map(dbToProd),logs:(logs.data||[]).map(dbToLog),templates:templates.data||[],users:teamMembers,movements:(movements.data||[]).map(dbToMovement),invoices,tradeDocs,notifications:notifsR?.data||[] };
  } catch(mapErr) {
    console.error("[SmartTraQ] Mapper error:",mapErr);
    return {orders:[],custs:[],vends:[],ships:[],tasks:[],rfqs:[],prods:[],logs:[],templates:[],users:[],movements:[],invoices:[],tradeDocs:[],notifications:[]};
  }
}

// ══════════════════════════════════════════════
// CRUD — Orders, Customers, Vendors, Shipments, Tasks, RFQs, Products
// ══════════════════════════════════════════════
export async function saveOrder(o,orgId,userId,setOrd) { if(!supabase)return null; const row=orderToDb(o,orgId,userId); if(o._uid){return(await supabase.from('orders').update(row).eq('id',o._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('orders').select('id').eq('org_id',orgId).eq('display_id',o.id).limit(1);if(existing&&existing.length>0){o._uid=existing[0].id;row.id=existing[0].id;if(setOrd)setOrd(prev=>prev.map(x=>x.id===o.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('orders').update(row).eq('id',o._uid)).error}const{data,error}=await supabase.from('orders').insert(row).select().single();if(data){o._uid=data.id;if(setOrd)setOrd(prev=>prev.map(x=>x.id===o.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteOrder(o) { if(!supabase||!o._uid)return null; return(await supabase.from('orders').delete().eq('id',o._uid)).error }
export async function saveCust(c,orgId,userId,setCst) { if(!supabase)return null; const row=custToDb(c,orgId,userId); if(c._uid){return(await supabase.from('customers').update(row).eq('id',c._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('customers').select('id').eq('org_id',orgId).eq('display_id',c.id).limit(1);if(existing&&existing.length>0){c._uid=existing[0].id;row.id=existing[0].id;if(setCst)setCst(prev=>prev.map(x=>x.id===c.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('customers').update(row).eq('id',c._uid)).error}const{data,error}=await supabase.from('customers').insert(row).select().single();if(data){c._uid=data.id;if(setCst)setCst(prev=>prev.map(x=>x.id===c.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteCust(c) { if(!supabase||!c._uid)return null; return(await supabase.from('customers').delete().eq('id',c._uid)).error }
export async function saveVend(v,orgId,userId,setVnd) { if(!supabase)return null; const row=vendToDb(v,orgId,userId); if(v._uid){return(await supabase.from('vendors').update(row).eq('id',v._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('vendors').select('id').eq('org_id',orgId).eq('display_id',v.id).limit(1);if(existing&&existing.length>0){v._uid=existing[0].id;row.id=existing[0].id;if(setVnd)setVnd(prev=>prev.map(x=>x.id===v.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('vendors').update(row).eq('id',v._uid)).error}const{data,error}=await supabase.from('vendors').insert(row).select().single();if(data){v._uid=data.id;if(setVnd)setVnd(prev=>prev.map(x=>x.id===v.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteVend(v) { if(!supabase||!v._uid)return null; return(await supabase.from('vendors').delete().eq('id',v._uid)).error }
export async function saveShip(s,orgId,userId,setShp) { if(!supabase)return null; const row=shipToDb(s,orgId,userId); if(s._uid){return(await supabase.from('shipments').update(row).eq('id',s._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('shipments').select('id').eq('org_id',orgId).eq('display_id',s.id).limit(1);if(existing&&existing.length>0){s._uid=existing[0].id;row.id=existing[0].id;if(setShp)setShp(prev=>prev.map(x=>x.id===s.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('shipments').update(row).eq('id',s._uid)).error}const{data,error}=await supabase.from('shipments').insert(row).select().single();if(data){s._uid=data.id;if(setShp)setShp(prev=>prev.map(x=>x.id===s.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteShip(s) { if(!supabase||!s._uid)return null; return(await supabase.from('shipments').delete().eq('id',s._uid)).error }
export async function saveTask(t,orgId,userId) { if(!supabase)return null; const{data,error}=await supabase.from('tasks').insert({org_id:orgId,title:t.title,ref_type:t.type,ref_id:t.refId||null,due_date:t.due||null,priority:t.priority,status:t.status||(t.done?'done':'todo'),assigned_name:(t.assignees||[])[0]||'',notes:t.note||'',subtasks:t.subtasks||[],reminder:t.reminder||null,created_by:userId}).select().single();if(data)t._uid=data.id;return error }
export async function updateTask(t,orgId) { if(!supabase||!t._uid)return null; return(await supabase.from('tasks').update({title:t.title,ref_type:t.type,ref_id:t.refId||null,due_date:t.due||null,priority:t.priority,status:t.status||(t.done?'done':'todo'),assigned_name:(t.assignees||[])[0]||'',notes:t.note||'',subtasks:t.subtasks||[],reminder:t.reminder||null,updated_at:new Date().toISOString()}).eq('id',t._uid)).error }
export async function dbDeleteTask(t) { if(!supabase||!t._uid)return null; return(await supabase.from('tasks').delete().eq('id',t._uid)).error }
export async function addLogEntry(act,cat,orgId,userId,userName) { if(!supabase)return null; return supabase.from('activity_log').insert({org_id:orgId,actor_id:userId,actor_name:userName,action:act,category:cat}) }
export async function saveRfq(r,orgId,userId,setRfqs) { if(!supabase)return null; const row=rfqToDb(r,orgId,userId); if(r._uid){return(await supabase.from('rfqs').update(row).eq('id',r._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('rfqs').select('id').eq('org_id',orgId).eq('display_id',r.id).limit(1);if(existing&&existing.length>0){r._uid=existing[0].id;row.id=existing[0].id;if(setRfqs)setRfqs(prev=>prev.map(x=>x.id===r.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('rfqs').update(row).eq('id',r._uid)).error}const{data,error}=await supabase.from('rfqs').insert(row).select().single();if(data){r._uid=data.id;if(setRfqs)setRfqs(prev=>prev.map(x=>x.id===r.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteRfq(r) { if(!supabase||!r._uid)return null; return(await supabase.from('rfqs').delete().eq('id',r._uid)).error }
export async function saveProd(p,orgId,userId,setProds) { if(!supabase)return null; const row=prodToDb(p,orgId,userId); if(p._uid){return(await supabase.from('products').update(row).eq('id',p._uid)).error}else{delete row.id;const{data:existing}=await supabase.from('products').select('id').eq('org_id',orgId).eq('display_id',p.id).limit(1);if(existing&&existing.length>0){p._uid=existing[0].id;row.id=existing[0].id;if(setProds)setProds(prev=>prev.map(x=>x.id===p.id?{...x,_uid:existing[0].id}:x));return(await supabase.from('products').update(row).eq('id',p._uid)).error}const{data,error}=await supabase.from('products').insert(row).select().single();if(data){p._uid=data.id;if(setProds)setProds(prev=>prev.map(x=>x.id===p.id?{...x,_uid:data.id}:x))}return error} }
export async function dbDeleteProd(p) { if(!supabase||!p._uid)return null; return(await supabase.from('products').delete().eq('id',p._uid)).error }

// ── Archive / Restore (soft delete) ──
// table: 'orders'|'customers'|'vendors'|'shipments'|'products'|'rfqs'
export async function archiveRecord(table, uid, userName) {
  if(!supabase||!uid) return null;
  return (await supabase.from(table).update({ archived_at: new Date().toISOString(), archived_by: userName||'System' }).eq('id', uid)).error;
}
export async function restoreRecord(table, uid) {
  if(!supabase||!uid) return null;
  return (await supabase.from(table).update({ archived_at: null, archived_by: null }).eq('id', uid)).error;
}
// Convenience wrappers matching existing import names
export async function archiveOrder(o, userId, userName) { return archiveRecord('orders', o._uid, userName); }
export async function restoreOrder(o, userId, userName) { return restoreRecord('orders', o._uid); }

// ── Stock Movements (with approval workflow) ──
export async function saveStockMovement(m, orgId, userId, userName) {
  if(!supabase) return { error:'no-supabase', id:null };
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const delta = parseFloat(m.qty) || 0;
  // Save as pending — stock does NOT change yet
  const { data, error } = await safe(
    supabase.from('stock_movements').insert({
      org_id:orgId, product_id:m.prodUid, product_display_id:m.prodId,
      product_name:m.prodName||'', type:m.type, qty:delta,
      reason:m.reason||'', order_id:m.orderId||null, notes:m.notes||'',
      status:'pending', created_by:userId, created_by_name:userName||'',
    }).select().single()
  );
  return { error, id: data?.id || null };
}

export async function approveMovement(movId, orgId, userId, userName) {
  if(!supabase||!movId) return { error:'missing', newQty:null };
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  // Fetch the movement
  const { data: mov } = await safe(supabase.from('stock_movements').select('*').eq('id',movId).single());
  if(!mov) return { error:'not-found', newQty:null };
  if(mov.status==='approved') return { error:null, newQty:mov.new_qty };
  const delta = parseFloat(mov.qty) || 0;
  // Fetch current stock
  const { data: prod } = await safe(supabase.from('products').select('stock_qty').eq('id',mov.product_id).single());
  const cur = parseFloat(prod?.stock_qty) || 0;
  const newQty = mov.type==='in' ? cur+delta : mov.type==='out' ? cur-delta : delta;
  // Update product stock
  await safe(supabase.from('products').update({stock_qty:newQty,updated_at:new Date().toISOString()}).eq('id',mov.product_id));
  // Update movement status
  await safe(supabase.from('stock_movements').update({
    status:'approved', new_qty:newQty,
    approved_by:userId, approved_by_name:userName||'',
    approved_at:new Date().toISOString(),
  }).eq('id',movId));
  return { error:null, newQty };
}

export async function rejectMovement(movId, userId, userName) {
  if(!supabase||!movId) return { error:'missing' };
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const { error } = await safe(supabase.from('stock_movements').update({
    status:'rejected',
    approved_by:userId, approved_by_name:userName||'',
    approved_at:new Date().toISOString(),
  }).eq('id',movId));
  return { error };
}

export async function loadStockMovements(orgId) {
  if(!supabase) return [];
  const safe = p => Promise.resolve(p).catch(e=>({data:[],error:e}));
  const { data } = await safe(supabase.from('stock_movements').select('*').eq('org_id',orgId).order('created_at',{ascending:false}).limit(500));
  return (data||[]).map(dbToMovement);
}

// ══════════════════════════════════════════════
// TRACKING PORTAL HELPERS
// ══════════════════════════════════════════════
export async function saveTrackToken(orgId,orderId,token,expiryDays,snapshot) {
  if(!supabase){return null}
  try{
    const row={order_display_id:orderId,token,expires_days:expiryDays||0,order_snapshot:snapshot||null};
    if(orgId)row.org_id=orgId;
    const{error}=await supabase.from('tracking_tokens').insert(row);
    if(error){console.error('[SmartTraQ] saveTrackToken error:',error.message);return null}
    return true;
  }catch(e){return null}
}
export async function fetchTrackToken(orderId,token) {
  if(!supabase)return null;
  try{const{data}=await supabase.from('tracking_tokens').select('*').eq('order_display_id',orderId).eq('token',token).eq('revoked',false).limit(1);return data&&data[0]?data[0]:null}catch(e){return null}
}
export async function markTokenViewed(orderId,token) {
  if(!supabase)return;
  await supabase.from('tracking_tokens').update({viewed:true,viewed_at:new Date().toISOString(),view_count:1}).eq('order_display_id',orderId).eq('token',token);
}
export async function revokeToken(orderId,token) {
  if(!supabase)return;
  await supabase.from('tracking_tokens').update({revoked:true}).eq('order_display_id',orderId).eq('token',token);
}
export async function updateTokenExpiry(orderId,token,days) {
  if(!supabase)return;
  await supabase.from('tracking_tokens').update({expires_days:days}).eq('order_display_id',orderId).eq('token',token);
}
export async function fetchOrgTokens(orgId) {
  if(!supabase)return[];
  const{data}=await supabase.from('tracking_tokens').select('*').eq('org_id',orgId).eq('revoked',false).order('created_at',{ascending:false});
  return data||[];
}
export async function sendPortalMessage(orderId,token,from,text,senderName) {
  if(!supabase||!text?.trim())return null;
  try{
    const{data}=await supabase.from('tracking_tokens').select('messages').eq('order_display_id',orderId).eq('token',token).limit(1);
    const existing=(data&&data[0]?.messages)||[];
    const msg={from,name:senderName||from,text:text.trim(),at:new Date().toISOString()};
    const updated=[...existing,msg];
    await supabase.from('tracking_tokens').update({messages:updated}).eq('order_display_id',orderId).eq('token',token);
    return updated;
  }catch(e){return null}
}
export async function fetchPortalMessages(orderId,token) {
  if(!supabase)return[];
  try{const{data}=await supabase.from('tracking_tokens').select('messages').eq('order_display_id',orderId).eq('token',token).limit(1);return(data&&data[0]?.messages)||[]}catch(e){return[]}
}

// ══════════════════════════════════════════════
// VENDOR PORTAL HELPERS
// ══════════════════════════════════════════════
export async function saveVendorToken(orgId,rfqId,vendorName,token,snapshot) {
  if(!supabase)return null;
  try{const row={rfq_id:rfqId,vendor_name:vendorName,token,rfq_snapshot:snapshot||null};if(orgId)row.org_id=orgId;const{error}=await supabase.from('vendor_tokens').insert(row);if(error){console.error('[SmartTraQ] saveVendorToken error:',error.message);return false}return true}catch(e){console.error('[SmartTraQ] saveVendorToken exception:',e);return null}
}
export async function fetchVendorToken(rfqId,token) {
  if(!supabase)return null;
  try{const{data}=await supabase.from('vendor_tokens').select('*').eq('rfq_id',rfqId).eq('token',token).eq('revoked',false).limit(1);return data&&data[0]?data[0]:null}catch(e){return null}
}
export async function markVendorViewed(rfqId,token) {
  if(!supabase)return;
  await supabase.from('vendor_tokens').update({viewed:true,viewed_at:new Date().toISOString()}).eq('rfq_id',rfqId).eq('token',token);
}
export async function fetchVendorMessages(rfqId,token) {
  if(!supabase)return[];
  try{const{data}=await supabase.from('vendor_tokens').select('messages').eq('rfq_id',rfqId).eq('token',token).limit(1);return(data&&data[0]?.messages)||[]}catch(e){return[]}
}
export async function sendVendorMessage(rfqId,token,from,text,senderName,file) {
  if(!supabase)return null;
  try{
    const{data}=await supabase.from('vendor_tokens').select('messages').eq('rfq_id',rfqId).eq('token',token).limit(1);
    const existing=(data&&data[0]?.messages)||[];
    const msg={from,name:senderName||from,text:(text||"").trim(),at:new Date().toISOString()};
    if(file)msg.file=file;
    const updated=[...existing,msg];
    await supabase.from('vendor_tokens').update({messages:updated}).eq('rfq_id',rfqId).eq('token',token);
    return updated;
  }catch(e){return null}
}
export async function fetchRfqVendorTokens(rfqId) {
  if(!supabase)return[];
  try{const{data}=await supabase.from('vendor_tokens').select('*').eq('rfq_id',rfqId).eq('revoked',false);return(data||[]).filter(t=>!t.revoked)}catch(e){return[]}
}
export async function revokeRfqVendorTokens(rfqId) {
  if(!supabase||!rfqId)return;
  try{
    await supabase.from('vendor_tokens').update({revoked:true,messages:[],vendor_response:[],response_status:'pending'}).eq('rfq_id',rfqId);
    await supabase.from('vendor_tokens').delete().eq('rfq_id',rfqId);
  }catch(e){}
}
export async function saveVendorResponse(rfqId,token,response,status) {
  if(!supabase)return false;
  try{await supabase.from('vendor_tokens').update({vendor_response:response,response_status:status||"submitted"}).eq('rfq_id',rfqId).eq('token',token);return true}catch(e){return false}
}

// ══════════════════════════════════════════════
// CUSTOMER DOCUMENT PORTAL HELPERS
// ══════════════════════════════════════════════
export async function saveCustomerToken(orgId,docId,customerName,token,docType,snapshot) {
  if(!supabase)return null;
  try{const row={doc_id:docId,customer_name:customerName||'',token,doc_type:docType||'so',doc_snapshot:snapshot||null};if(orgId)row.org_id=orgId;const{error}=await supabase.from('customer_tokens').insert(row);if(error){console.error('[SmartTraQ] saveCustomerToken error:',error.message);return false}return true}catch(e){console.error('[SmartTraQ] saveCustomerToken exception:',e);return null}
}
export async function fetchCustomerToken(docId,token) {
  if(!supabase)return null;
  try{const{data}=await supabase.from('customer_tokens').select('*').eq('doc_id',docId).eq('token',token).eq('revoked',false).limit(1);return data&&data[0]?data[0]:null}catch(e){return null}
}
export async function markCustomerViewed(docId,token) {
  if(!supabase)return;
  await supabase.from('customer_tokens').update({viewed:true,viewed_at:new Date().toISOString(),view_count:1}).eq('doc_id',docId).eq('token',token);
}
export async function fetchCustomerMessages(docId,token) {
  if(!supabase)return[];
  try{const{data}=await supabase.from('customer_tokens').select('messages').eq('doc_id',docId).eq('token',token).limit(1);return(data&&data[0]?.messages)||[]}catch(e){return[]}
}
export async function sendCustomerMessage(docId,token,from,text,senderName,file) {
  if(!supabase)return null;
  try{
    const{data}=await supabase.from('customer_tokens').select('messages').eq('doc_id',docId).eq('token',token).limit(1);
    const existing=(data&&data[0]?.messages)||[];
    const msg={from,name:senderName||from,text:(text||"").trim(),at:new Date().toISOString()};
    if(file)msg.file=file;
    const updated=[...existing,msg];
    await supabase.from('customer_tokens').update({messages:updated}).eq('doc_id',docId).eq('token',token);
    return updated;
  }catch(e){return null}
}
export async function fetchDocCustomerTokens(docId) {
  if(!supabase)return[];
  try{const{data}=await supabase.from('customer_tokens').select('*').eq('doc_id',docId).eq('revoked',false);return(data||[]).filter(t=>!t.revoked)}catch(e){return[]}
}
export async function revokeDocCustomerTokens(docId) {
  if(!supabase||!docId)return;
  try{await supabase.from('customer_tokens').update({revoked:true}).eq('doc_id',docId)}catch(e){}
}
export async function saveCustomerResponse(docId,token,response,status) {
  if(!supabase)return false;
  try{await supabase.from('customer_tokens').update({customer_response:response,response_status:status||"approved",updated_at:new Date().toISOString()}).eq('doc_id',docId).eq('token',token);return true}catch(e){return false}
}

// ══════════════════════════════════════════════
// INVOICES
// ══════════════════════════════════════════════
export async function saveInvoice(inv, orgId, userId) {
  if(!supabase) return null;
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const row = { org_id: orgId, display_id: inv.id, data: inv, updated_at: new Date().toISOString() };
  if(inv._uid) {
    return (await safe(supabase.from('invoices').update({ data: inv, updated_at: row.updated_at }).eq('id', inv._uid))).error;
  } else {
    row.created_by = userId;
    const { data, error } = await safe(supabase.from('invoices').insert(row).select().single());
    if(data) inv._uid = data.id;
    return error;
  }
}
export async function deleteInvoice(inv) {
  if(!supabase || !inv._uid) return null;
  return (await supabase.from('invoices').delete().eq('id', inv._uid)).error;
}

// ══════════════════════════════════════════════
// TRADE DOCS
// ══════════════════════════════════════════════
export async function saveTradeDoc(doc, orgId, userId) {
  if(!supabase) return null;
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const row = { org_id: orgId, display_id: doc.id, doc_type: doc.type || 'ci', order_id: doc.orderId || null, data: doc, updated_at: new Date().toISOString() };
  if(doc._uid) {
    return (await safe(supabase.from('trade_docs').update({ data: doc, doc_type: doc.type || 'ci', order_id: doc.orderId || null, updated_at: row.updated_at }).eq('id', doc._uid))).error;
  } else {
    row.created_by = userId;
    const { data, error } = await safe(supabase.from('trade_docs').insert(row).select().single());
    if(data) doc._uid = data.id;
    return error;
  }
}
export async function deleteTradeDoc(doc) {
  if(!supabase || !doc._uid) return null;
  return (await supabase.from('trade_docs').delete().eq('id', doc._uid)).error;
}

// ══════════════════════════════════════════════
// HS CODE AI CLASSIFIER
// ══════════════════════════════════════════════
export async function suggestHSCode({ productName, description, category, destination }) {
  if(!supabase) return { error:'no-supabase', suggestions:[] };
  try {
    const dest = destination || 'UAE';
    const isGCC = ['UAE','Saudi Arabia','Qatar','Kuwait','Bahrain','Oman','KSA','SA','QA','KW','BH','OM'].some(c => dest.toUpperCase().includes(c.toUpperCase()));
    const systemPrompt = `You are an expert customs classifier specializing in HS (Harmonized System) commodity codes used in international trade.

Given a product description, return the top 3 most likely HS codes as a JSON array. Each entry must have:
- "hs6": the 6-digit international HS code (string, format "XXXX.XX")
- "regional": the 8-digit regional code if destination is GCC/UAE (format "XXXX.XX.XX"), otherwise empty string
- "description": official HS description (short, max 80 chars)
- "confidence": confidence level ("high", "medium", or "low")

${isGCC ? 'Destination is GCC region. Provide 8-digit GCC Common External Tariff codes. Standard GCC duty is 5% on most goods, 0% on essentials, 50-100% on tobacco/alcohol.' : 'Destination: ' + dest + '. Provide 6-digit international codes only.'}

Return ONLY a valid JSON array, no markdown, no explanation. Example:
[{"hs6":"7108.12","regional":"7108.12.00","description":"Gold in unwrought forms, non-monetary","confidence":"high"}]`;

    const userMsg = `Product: ${productName || 'Unknown'}${description ? '\nDescription: ' + description : ''}${category ? '\nCategory: ' + category : ''}\nDestination: ${dest}`;

    const { data, error } = await supabase.functions.invoke('ai-proxy', {
      body: { type: "text", model: "claude-haiku-4-5-20251001", system: systemPrompt, userMessage: userMsg, max_tokens: 600 }
    });
    if (error) {
      let msg = error.message || 'Edge function error';
      // Try to extract response body from non-2xx for real error details
      try { if (error.context) { const body = await error.context.json(); msg = body?.error?.message || body?.error || body?.message || msg; console.error('[SmartTraQ] HS response body:', body); } } catch(e2) {}
      console.error('[SmartTraQ] HS proxy error:', msg);
      return { error: msg, suggestions: [] };
    }
    if (data?.error) { console.error('[SmartTraQ] HS data error:', data.error); return { error: typeof data.error === 'string' ? data.error : JSON.stringify(data.error), suggestions: [] }; }
    // Extract text — Edge Function may return { text: "..." } or raw string
    const text = typeof data === 'string' ? data : (data?.text || data?.content || data?.result || JSON.stringify(data) || '');
    console.log('[SmartTraQ] HS raw response:', text.slice(0, 300));
    // Robust JSON extraction: find first [ and last ]
    const start = text.indexOf('[');
    const end = text.lastIndexOf(']');
    if (start === -1 || end === -1 || end <= start) { console.error('[SmartTraQ] HS no JSON array found in:', text.slice(0, 200)); return { error: 'AI response missing JSON array', suggestions: [] }; }
    const jsonStr = text.slice(start, end + 1);
    const suggestions = JSON.parse(jsonStr);
    return { error: null, suggestions: Array.isArray(suggestions) ? suggestions.slice(0, 3) : [] };
  } catch (e) {
    console.error('[SmartTraQ] HS suggest error:', e);
    return { error: e.message, suggestions: [] };
  }
}

// ══════════════════════════════════════════════
// EMAIL
// ══════════════════════════════════════════════
export async function sendEmailViaResend({to,subject,html,from}) {
  if(!supabase)return{ok:false,error:"Supabase not connected. Use Copy HTML instead."};
  try{
    const sender=from||"SmartTraQ <noreply@smarttraq.io>";
    const{data,error}=await supabase.functions.invoke('send-email',{body:{
      to,subject,html,from:sender,
      reply_to:"support@smarttraq.io",
      headers:{
        "X-Entity-Ref-ID":Date.now().toString(36),
        "List-Unsubscribe":"<mailto:unsubscribe@smarttraq.io?subject=unsubscribe>"
      },
      text:subject+" - View this email in HTML for the full experience. Sent via SmartTraQ."
    }});
    if(error){
      const msg=error.message||"";
      if(msg.includes("non-2xx")||msg.includes("validation_error"))return{ok:false,error:"Email service error. Verify your domain in Resend dashboard (resend.com/domains) to fix Gmail delivery."};
      return{ok:false,error:msg||"Edge function error"};
    }
    if(data?.error)return{ok:false,error:data.error};
    return{ok:true,id:data?.id};
  }catch(e){return{ok:false,error:"Network error: "+e.message}}
}

// ══════════════════════════════════════════════
// NOTIFICATIONS
// ══════════════════════════════════════════════
export async function createNotification({ orgId, userId, type, title, message, refType, refId, actorId, actorName }) {
  if(!supabase) return null;
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const { error } = await safe(supabase.from('notifications').insert({
    org_id: orgId, user_id: userId || null,
    type: type || 'info', title, message: message || '',
    ref_type: refType || '', ref_id: refId || '',
    actor_id: actorId || null, actor_name: actorName || '',
  }));
  return error;
}

export async function createTeamNotification({ orgId, users, type, title, message, refType, refId, actorId, actorName }) {
  if(!supabase || !users?.length) return;
  const safe = p => Promise.resolve(p).catch(e=>({data:null,error:e}));
  const rows = users
    .filter(u => u.id !== actorId && u.on !== false)
    .map(u => ({
      org_id: orgId, user_id: u.id,
      type: type || 'info', title, message: message || '',
      ref_type: refType || '', ref_id: refId || '',
      actor_id: actorId || null, actor_name: actorName || '',
    }));
  if(rows.length === 0) return;
  await safe(supabase.from('notifications').insert(rows));
}

export async function loadNotifications(orgId, userId) {
  if(!supabase) return [];
  const safe = p => Promise.resolve(p).catch(e=>({data:[],error:e}));
  const { data } = await safe(
    supabase.from('notifications').select('*')
      .eq('org_id', orgId)
      .or(`user_id.eq.${userId},user_id.is.null`)
      .order('created_at', { ascending: false })
      .limit(100)
  );
  return data || [];
}

export async function markNotifRead(notifId) {
  if(!supabase || !notifId) return;
  await supabase.from('notifications').update({ read: true, read_at: new Date().toISOString() }).eq('id', notifId);
}

export async function markAllNotifsRead(orgId, userId) {
  if(!supabase) return;
  await supabase.from('notifications').update({ read: true, read_at: new Date().toISOString() })
    .eq('org_id', orgId)
    .or(`user_id.eq.${userId},user_id.is.null`)
    .eq('read', false);
}
